import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { PercentChange } from './period';
import { StatDelta } from './StatDelta';

interface Props {
  label: ReactNode;
  value: ReactNode;
  change?: PercentChange;
  /** Whether an increase is a good thing (drives the delta chip colour). Defaults to true. */
  higherIsBetter?: boolean;
  caption?: ReactNode;
  icon?: ReactNode;
}

export const StatTile = ({ label, value, change, higherIsBetter = true, caption, icon }: Props) => (
  <Stack gap={0.5} sx={{ minWidth: 0 }}>
    <Stack direction="row" alignItems="center" gap={1}>
      {icon}
      <Typography variant="body2" color="text.secondary" noWrap>
        {label}
      </Typography>
    </Stack>
    <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
      <Typography variant="h4" fontWeight={600} lineHeight={1.1}>
        {value}
      </Typography>
      {change && <StatDelta change={change} higherIsBetter={higherIsBetter} />}
    </Stack>
    {caption && (
      <Typography variant="caption" color="text.secondary">
        {caption}
      </Typography>
    )}
  </Stack>
);
